module.exports = __webpack_public_path__ + "static/1_2-ee35f559106bdae5348bd45499f23cf6.mp4";